import { gql } from '@apollo/client';

export const GET_ALL_QUESTIONS = gql`
  query GetAllQuestions {
    getQuestionsPaginated(limit: 10000, offset: 0) {
      questions {
        id
        prompt
        options {
          desc
          isAnswer
        }
        explanation
        tag
        label
      }
      totalCount
    }
  }
`;
